// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__WS9bt","sendOtp":"AuthorizeToLogin_sendOtp__29EWX"};